import { createTheme, Theme } from '@mui/material/styles';
import { lightTheme } from './light';
import empresaJson from './empresa1.json';
import { useIsEscolaLegislativo, useIsSaber, useIsSite } from '../utils/qualSistema';
import { setThemeSelecionado } from './themeSelecionadoSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export async function loadThemeFromJson(configPath: string): Promise<Theme> {
  const res = await fetch(configPath);
  const config = await res.json();
  return createTheme(config);
}
export function useLoadTheme(): Theme {
  const dispatch = useDispatch();

  const isSaber = useIsSaber();
  const isSite = useIsSite();
  const isEscola = useIsEscolaLegislativo();

  let themeToAppy: any = lightTheme;
  let siteTitle = 'React App';

  if (isSite || isEscola) {
    themeToAppy = empresaJson;
    siteTitle = empresaJson.custom?.nome ?? 'Empresa';
  }

  // Redux
  useEffect(() => {
    dispatch(setThemeSelecionado(isSite || isEscola ? 'empresa1' : 'DEFAULT_LIGHT'));
  }, [dispatch, isSite, isEscola]);

  // Título + favicon
  useEffect(() => {
    document.title = siteTitle;

    let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    favicon.href = '/images/brasao.jpg';
  }, [siteTitle]);

  return createTheme(themeToAppy);
}
